define(['angular'], function(angular) {
    function MvtsService($http, devance) {
        var self = this;
        self.backUrl = devance.getBdcUrl();

        self.listParcMvtsTypes = function() {
            return $http.get(self.backUrl + 'devance/pos-movements-types')
                .then(res => {
                    return res.data;
                });
        };

        self.listServMvtsTypes = function() {
            return $http.get(self.backUrl + 'devance/services-movements-types')
                .then(res => {
                    return res.data;
                });
        };

        self.listParcStatus = function() {
            return $http.get(self.backUrl + 'devance/pos-status')
                .then(res => {
                    return res.data;
                });
        };

        self.listServStatus = function() {
            return $http.get(self.backUrl + 'devance/services-status')
                .then(res => {
                    return res.data;
                });
        };

        self.countMvts = function(params) {
            return $http.post(self.backUrl + 'devance/count-movements', params)
                .then(res => {
                    return res.data;
                });
        };

        self.listMvts = function(params) {
            return $http.post(self.backUrl + 'devance/list-movements', params)
                .then(res => {
                    return res.data;
                });
        };

        self.getDevancePosInfos = function(diod) {
            return $http.get(self.backUrl + 'devance/pos/' + diod)
                .then(res => {
                    return res.data;
                });
        };

        self.getX3PosSearch = function(devPosInfos) {
            return $http.post(self.backUrl + 'devance/pos/x3/search', devPosInfos)
                .then(res => {
                    return res.data;
                });
        };

        self.getX3PosByDiod = function(diod) {
            return $http.get(self.backUrl + 'devance/pos/x3/search/' + diod)
                .then(res => {
                    return res.data;
                });
        };

        self.updateMvtStatus = function(diod, type, date_demande, status) {
            return $http.post(self.backUrl + 'devance/update-movement', [diod, type, date_demande, status])
                .then(res => {
                    return res.data;
                });
        }

        self.downloadFile = function(link) {
            return $http.post(self.backUrl + 'devance/document',
                { link }, { responseType: 'arraybuffer' })
                .then(function (res) {
                    return res;
                });
        }

        return self;
    }

    MvtsService.$inject = [
        '$http', 'devance'
    ];

    angular.module('app.devance.movements.mvtsService', [])
        .factory('mvtsService', MvtsService);
});
